@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package eu.codlab.weather.common.compose.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val weather_200: StringResource by 
      lazy { init_weather_200() }

  public val weather_201: StringResource by 
      lazy { init_weather_201() }

  public val weather_202: StringResource by 
      lazy { init_weather_202() }

  public val weather_210: StringResource by 
      lazy { init_weather_210() }

  public val weather_211: StringResource by 
      lazy { init_weather_211() }

  public val weather_212: StringResource by 
      lazy { init_weather_212() }

  public val weather_221: StringResource by 
      lazy { init_weather_221() }

  public val weather_230: StringResource by 
      lazy { init_weather_230() }

  public val weather_231: StringResource by 
      lazy { init_weather_231() }

  public val weather_232: StringResource by 
      lazy { init_weather_232() }

  public val weather_300: StringResource by 
      lazy { init_weather_300() }

  public val weather_301: StringResource by 
      lazy { init_weather_301() }

  public val weather_302: StringResource by 
      lazy { init_weather_302() }

  public val weather_310: StringResource by 
      lazy { init_weather_310() }

  public val weather_311: StringResource by 
      lazy { init_weather_311() }

  public val weather_312: StringResource by 
      lazy { init_weather_312() }

  public val weather_313: StringResource by 
      lazy { init_weather_313() }

  public val weather_314: StringResource by 
      lazy { init_weather_314() }

  public val weather_321: StringResource by 
      lazy { init_weather_321() }

  public val weather_500: StringResource by 
      lazy { init_weather_500() }

  public val weather_501: StringResource by 
      lazy { init_weather_501() }

  public val weather_502: StringResource by 
      lazy { init_weather_502() }

  public val weather_503: StringResource by 
      lazy { init_weather_503() }

  public val weather_504: StringResource by 
      lazy { init_weather_504() }

  public val weather_511: StringResource by 
      lazy { init_weather_511() }

  public val weather_520: StringResource by 
      lazy { init_weather_520() }

  public val weather_521: StringResource by 
      lazy { init_weather_521() }

  public val weather_522: StringResource by 
      lazy { init_weather_522() }

  public val weather_531: StringResource by 
      lazy { init_weather_531() }

  public val weather_600: StringResource by 
      lazy { init_weather_600() }

  public val weather_601: StringResource by 
      lazy { init_weather_601() }

  public val weather_602: StringResource by 
      lazy { init_weather_602() }

  public val weather_611: StringResource by 
      lazy { init_weather_611() }

  public val weather_612: StringResource by 
      lazy { init_weather_612() }

  public val weather_613: StringResource by 
      lazy { init_weather_613() }

  public val weather_615: StringResource by 
      lazy { init_weather_615() }

  public val weather_616: StringResource by 
      lazy { init_weather_616() }

  public val weather_620: StringResource by 
      lazy { init_weather_620() }

  public val weather_621: StringResource by 
      lazy { init_weather_621() }

  public val weather_622: StringResource by 
      lazy { init_weather_622() }

  public val weather_701: StringResource by 
      lazy { init_weather_701() }

  public val weather_711: StringResource by 
      lazy { init_weather_711() }

  public val weather_721: StringResource by 
      lazy { init_weather_721() }

  public val weather_731: StringResource by 
      lazy { init_weather_731() }

  public val weather_741: StringResource by 
      lazy { init_weather_741() }

  public val weather_751: StringResource by 
      lazy { init_weather_751() }

  public val weather_761: StringResource by 
      lazy { init_weather_761() }

  public val weather_762: StringResource by 
      lazy { init_weather_762() }

  public val weather_771: StringResource by 
      lazy { init_weather_771() }

  public val weather_781: StringResource by 
      lazy { init_weather_781() }

  public val weather_800: StringResource by 
      lazy { init_weather_800() }

  public val weather_801: StringResource by 
      lazy { init_weather_801() }

  public val weather_802: StringResource by 
      lazy { init_weather_802() }

  public val weather_803: StringResource by 
      lazy { init_weather_803() }

  public val weather_804: StringResource by 
      lazy { init_weather_804() }

  public val weather_title_clear: StringResource by 
      lazy { init_weather_title_clear() }

  public val weather_title_clouds: StringResource by 
      lazy { init_weather_title_clouds() }

  public val weather_title_drizzle: StringResource by 
      lazy { init_weather_title_drizzle() }

  public val weather_title_rain: StringResource by 
      lazy { init_weather_title_rain() }

  public val weather_title_snow: StringResource by 
      lazy { init_weather_title_snow() }

  public val weather_title_thunderstorm: StringResource by 
      lazy { init_weather_title_thunderstorm() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("weather_200", CommonMainString0.weather_200)
  map.put("weather_201", CommonMainString0.weather_201)
  map.put("weather_202", CommonMainString0.weather_202)
  map.put("weather_210", CommonMainString0.weather_210)
  map.put("weather_211", CommonMainString0.weather_211)
  map.put("weather_212", CommonMainString0.weather_212)
  map.put("weather_221", CommonMainString0.weather_221)
  map.put("weather_230", CommonMainString0.weather_230)
  map.put("weather_231", CommonMainString0.weather_231)
  map.put("weather_232", CommonMainString0.weather_232)
  map.put("weather_300", CommonMainString0.weather_300)
  map.put("weather_301", CommonMainString0.weather_301)
  map.put("weather_302", CommonMainString0.weather_302)
  map.put("weather_310", CommonMainString0.weather_310)
  map.put("weather_311", CommonMainString0.weather_311)
  map.put("weather_312", CommonMainString0.weather_312)
  map.put("weather_313", CommonMainString0.weather_313)
  map.put("weather_314", CommonMainString0.weather_314)
  map.put("weather_321", CommonMainString0.weather_321)
  map.put("weather_500", CommonMainString0.weather_500)
  map.put("weather_501", CommonMainString0.weather_501)
  map.put("weather_502", CommonMainString0.weather_502)
  map.put("weather_503", CommonMainString0.weather_503)
  map.put("weather_504", CommonMainString0.weather_504)
  map.put("weather_511", CommonMainString0.weather_511)
  map.put("weather_520", CommonMainString0.weather_520)
  map.put("weather_521", CommonMainString0.weather_521)
  map.put("weather_522", CommonMainString0.weather_522)
  map.put("weather_531", CommonMainString0.weather_531)
  map.put("weather_600", CommonMainString0.weather_600)
  map.put("weather_601", CommonMainString0.weather_601)
  map.put("weather_602", CommonMainString0.weather_602)
  map.put("weather_611", CommonMainString0.weather_611)
  map.put("weather_612", CommonMainString0.weather_612)
  map.put("weather_613", CommonMainString0.weather_613)
  map.put("weather_615", CommonMainString0.weather_615)
  map.put("weather_616", CommonMainString0.weather_616)
  map.put("weather_620", CommonMainString0.weather_620)
  map.put("weather_621", CommonMainString0.weather_621)
  map.put("weather_622", CommonMainString0.weather_622)
  map.put("weather_701", CommonMainString0.weather_701)
  map.put("weather_711", CommonMainString0.weather_711)
  map.put("weather_721", CommonMainString0.weather_721)
  map.put("weather_731", CommonMainString0.weather_731)
  map.put("weather_741", CommonMainString0.weather_741)
  map.put("weather_751", CommonMainString0.weather_751)
  map.put("weather_761", CommonMainString0.weather_761)
  map.put("weather_762", CommonMainString0.weather_762)
  map.put("weather_771", CommonMainString0.weather_771)
  map.put("weather_781", CommonMainString0.weather_781)
  map.put("weather_800", CommonMainString0.weather_800)
  map.put("weather_801", CommonMainString0.weather_801)
  map.put("weather_802", CommonMainString0.weather_802)
  map.put("weather_803", CommonMainString0.weather_803)
  map.put("weather_804", CommonMainString0.weather_804)
  map.put("weather_title_clear", CommonMainString0.weather_title_clear)
  map.put("weather_title_clouds", CommonMainString0.weather_title_clouds)
  map.put("weather_title_drizzle", CommonMainString0.weather_title_drizzle)
  map.put("weather_title_rain", CommonMainString0.weather_title_rain)
  map.put("weather_title_snow", CommonMainString0.weather_title_snow)
  map.put("weather_title_thunderstorm", CommonMainString0.weather_title_thunderstorm)
}

internal val Res.string.weather_200: StringResource
  get() = CommonMainString0.weather_200

private fun init_weather_200(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_200", "weather_200",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr", 10,
    55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 10, 59),
    )
)

internal val Res.string.weather_201: StringResource
  get() = CommonMainString0.weather_201

private fun init_weather_201(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_201", "weather_201",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr", 66,
    43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 70, 51),
    )
)

internal val Res.string.weather_202: StringResource
  get() = CommonMainString0.weather_202

private fun init_weather_202(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_202", "weather_202",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    110, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 122, 59),
    )
)

internal val Res.string.weather_210: StringResource
  get() = CommonMainString0.weather_210

private fun init_weather_210(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_210", "weather_210",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    162, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 182, 43),
    )
)

internal val Res.string.weather_211: StringResource
  get() = CommonMainString0.weather_211

private fun init_weather_211(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_211", "weather_211",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    198, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 226, 35),
    )
)

internal val Res.string.weather_212: StringResource
  get() = CommonMainString0.weather_212

private fun init_weather_212(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_212", "weather_212",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    226, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 262, 43),
    )
)

internal val Res.string.weather_221: StringResource
  get() = CommonMainString0.weather_221

private fun init_weather_221(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_221", "weather_221",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    262, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 306, 47),
    )
)

internal val Res.string.weather_230: StringResource
  get() = CommonMainString0.weather_230

private fun init_weather_230(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_230", "weather_230",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    306, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 354, 63),
    )
)

internal val Res.string.weather_231: StringResource
  get() = CommonMainString0.weather_231

private fun init_weather_231(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_231", "weather_231",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    362, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 418, 55),
    )
)

internal val Res.string.weather_232: StringResource
  get() = CommonMainString0.weather_232

private fun init_weather_232(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_232", "weather_232",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    406, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 474, 63),
    )
)

internal val Res.string.weather_300: StringResource
  get() = CommonMainString0.weather_300

private fun init_weather_300(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_300", "weather_300",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    458, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 538, 51),
    )
)

internal val Res.string.weather_301: StringResource
  get() = CommonMainString0.weather_301

private fun init_weather_301(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_301", "weather_301",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    498, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 590, 31),
    )
)

internal val Res.string.weather_302: StringResource
  get() = CommonMainString0.weather_302

private fun init_weather_302(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_302", "weather_302",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    526, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 622, 51),
    )
)

internal val Res.string.weather_310: StringResource
  get() = CommonMainString0.weather_310

private fun init_weather_310(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_310", "weather_310",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    562, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 674, 59),
    )
)

internal val Res.string.weather_311: StringResource
  get() = CommonMainString0.weather_311

private fun init_weather_311(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_311", "weather_311",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    614, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 734, 35),
    )
)

internal val Res.string.weather_312: StringResource
  get() = CommonMainString0.weather_312

private fun init_weather_312(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_312", "weather_312",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    654, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 770, 59),
    )
)

internal val Res.string.weather_313: StringResource
  get() = CommonMainString0.weather_313

private fun init_weather_313(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_313", "weather_313",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    702, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 830, 51),
    )
)

internal val Res.string.weather_314: StringResource
  get() = CommonMainString0.weather_314

private fun init_weather_314(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_314", "weather_314",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    746, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 882, 59),
    )
)

internal val Res.string.weather_321: StringResource
  get() = CommonMainString0.weather_321

private fun init_weather_321(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_321", "weather_321",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    798, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 942, 39),
    )
)

internal val Res.string.weather_500: StringResource
  get() = CommonMainString0.weather_500

private fun init_weather_500(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_500", "weather_500",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    842, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 982, 35),
    )
)

internal val Res.string.weather_501: StringResource
  get() = CommonMainString0.weather_501

private fun init_weather_501(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_501", "weather_501",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    882, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1018,
    39),
    )
)

internal val Res.string.weather_502: StringResource
  get() = CommonMainString0.weather_502

private fun init_weather_502(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_502", "weather_502",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    922, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1058,
    47),
    )
)

internal val Res.string.weather_503: StringResource
  get() = CommonMainString0.weather_503

private fun init_weather_503(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_503", "weather_503",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    958, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1106,
    39),
    )
)

internal val Res.string.weather_504: StringResource
  get() = CommonMainString0.weather_504

private fun init_weather_504(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_504", "weather_504",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1002, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1146,
    35),
    )
)

internal val Res.string.weather_511: StringResource
  get() = CommonMainString0.weather_511

private fun init_weather_511(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_511", "weather_511",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1042, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1182,
    39),
    )
)

internal val Res.string.weather_520: StringResource
  get() = CommonMainString0.weather_520

private fun init_weather_520(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_520", "weather_520",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1086, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1222,
    55),
    )
)

internal val Res.string.weather_521: StringResource
  get() = CommonMainString0.weather_521

private fun init_weather_521(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_521", "weather_521",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1138, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1278,
    35),
    )
)

internal val Res.string.weather_522: StringResource
  get() = CommonMainString0.weather_522

private fun init_weather_522(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_522", "weather_522",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1182, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1314,
    55),
    )
)

internal val Res.string.weather_531: StringResource
  get() = CommonMainString0.weather_531

private fun init_weather_531(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_531", "weather_531",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1234, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1370,
    43),
    )
)

internal val Res.string.weather_600: StringResource
  get() = CommonMainString0.weather_600

private fun init_weather_600(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_600", "weather_600",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1286, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1414,
    35),
    )
)

internal val Res.string.weather_601: StringResource
  get() = CommonMainString0.weather_601

private fun init_weather_601(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_601", "weather_601",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1326, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1450,
    27),
    )
)

internal val Res.string.weather_602: StringResource
  get() = CommonMainString0.weather_602

private fun init_weather_602(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_602", "weather_602",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1354, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1478,
    35),
    )
)

internal val Res.string.weather_611: StringResource
  get() = CommonMainString0.weather_611

private fun init_weather_611(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_611", "weather_611",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1390, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1514,
    27),
    )
)

internal val Res.string.weather_612: StringResource
  get() = CommonMainString0.weather_612

private fun init_weather_612(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_612", "weather_612",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1422, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1542,
    43),
    )
)

internal val Res.string.weather_613: StringResource
  get() = CommonMainString0.weather_613

private fun init_weather_613(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_613", "weather_613",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1482, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1586,
    35),
    )
)

internal val Res.string.weather_615: StringResource
  get() = CommonMainString0.weather_615

private fun init_weather_615(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_615", "weather_615",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1526, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1622,
    47),
    )
)

internal val Res.string.weather_616: StringResource
  get() = CommonMainString0.weather_616

private fun init_weather_616(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_616", "weather_616",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1578, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1670,
    39),
    )
)

internal val Res.string.weather_620: StringResource
  get() = CommonMainString0.weather_620

private fun init_weather_620(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_620", "weather_620",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1618, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1710,
    43),
    )
)

internal val Res.string.weather_621: StringResource
  get() = CommonMainString0.weather_621

private fun init_weather_621(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_621", "weather_621",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1674, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1754,
    35),
    )
)

internal val Res.string.weather_622: StringResource
  get() = CommonMainString0.weather_622

private fun init_weather_622(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_622", "weather_622",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1718, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1790,
    43),
    )
)

internal val Res.string.weather_701: StringResource
  get() = CommonMainString0.weather_701

private fun init_weather_701(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_701", "weather_701",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1770, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1834,
    27),
    )
)

internal val Res.string.weather_711: StringResource
  get() = CommonMainString0.weather_711

private fun init_weather_711(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_711", "weather_711",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1806, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1862,
    27),
    )
)

internal val Res.string.weather_721: StringResource
  get() = CommonMainString0.weather_721

private fun init_weather_721(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_721", "weather_721",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1834, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1890,
    27),
    )
)

internal val Res.string.weather_731: StringResource
  get() = CommonMainString0.weather_731

private fun init_weather_731(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_731", "weather_731",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1862, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1918,
    43),
    )
)

internal val Res.string.weather_741: StringResource
  get() = CommonMainString0.weather_741

private fun init_weather_741(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_741", "weather_741",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1926, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1962,
    23),
    )
)

internal val Res.string.weather_751: StringResource
  get() = CommonMainString0.weather_751

private fun init_weather_751(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_751", "weather_751",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1962, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 1986,
    27),
    )
)

internal val Res.string.weather_761: StringResource
  get() = CommonMainString0.weather_761

private fun init_weather_761(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_761", "weather_761",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    1990, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2014,
    27),
    )
)

internal val Res.string.weather_762: StringResource
  get() = CommonMainString0.weather_762

private fun init_weather_762(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_762", "weather_762",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2026, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2042,
    35),
    )
)

internal val Res.string.weather_771: StringResource
  get() = CommonMainString0.weather_771

private fun init_weather_771(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_771", "weather_771",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2074, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2078,
    31),
    )
)

internal val Res.string.weather_781: StringResource
  get() = CommonMainString0.weather_781

private fun init_weather_781(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_781", "weather_781",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2106, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2110,
    31),
    )
)

internal val Res.string.weather_800: StringResource
  get() = CommonMainString0.weather_800

private fun init_weather_800(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_800", "weather_800",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2138, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2142,
    31),
    )
)

internal val Res.string.weather_801: StringResource
  get() = CommonMainString0.weather_801

private fun init_weather_801(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_801", "weather_801",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2178, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2174,
    35),
    )
)

internal val Res.string.weather_802: StringResource
  get() = CommonMainString0.weather_802

private fun init_weather_802(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_802", "weather_802",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2218, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2210,
    43),
    )
)

internal val Res.string.weather_803: StringResource
  get() = CommonMainString0.weather_803

private fun init_weather_803(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_803", "weather_803",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2262, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2254,
    39),
    )
)

internal val Res.string.weather_804: StringResource
  get() = CommonMainString0.weather_804

private fun init_weather_804(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:weather_804", "weather_804",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2306, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2294,
    39),
    )
)

internal val Res.string.weather_title_clear: StringResource
  get() = CommonMainString0.weather_title_clear

private fun init_weather_title_clear(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_clear", "weather_title_clear",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2346, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2334,
    35),
    )
)

internal val Res.string.weather_title_clouds: StringResource
  get() = CommonMainString0.weather_title_clouds

private fun init_weather_title_clouds(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_clouds", "weather_title_clouds",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2382, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2370,
    36),
    )
)

internal val Res.string.weather_title_drizzle: StringResource
  get() = CommonMainString0.weather_title_drizzle

private fun init_weather_title_drizzle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_drizzle", "weather_title_drizzle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2423, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2407,
    41),
    )
)

internal val Res.string.weather_title_rain: StringResource
  get() = CommonMainString0.weather_title_rain

private fun init_weather_title_rain(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_rain", "weather_title_rain",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2461, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2449,
    34),
    )
)

internal val Res.string.weather_title_snow: StringResource
  get() = CommonMainString0.weather_title_snow

private fun init_weather_title_snow(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_snow", "weather_title_snow",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2496, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2484,
    34),
    )
)

internal val Res.string.weather_title_thunderstorm: StringResource
  get() = CommonMainString0.weather_title_thunderstorm

private fun init_weather_title_thunderstorm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:weather_title_thunderstorm", "weather_title_thunderstorm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ), "composeResources/eu.codlab.weather.common.compose.res/values-fr/strings.commonMain.cvr",
    2531, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/eu.codlab.weather.common.compose.res/values/strings.commonMain.cvr", 2519,
    50),
    )
)
